import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import resourceicon from "../assets/image/resourceicon.svg";
import newbeg from "../assets/image/new-beg.webp";
import RSVPModal from "../components/RSVPModal";

function SinglesFellowship() {
  const token = localStorage.getItem("authToken");
  const [rsvpOpen, setRsvpOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [resources, setResources] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loadingResources, setLoadingResources] = useState(true);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [resourcesError, setResourcesError] = useState(null);
  const [eventsError, setEventsError] = useState(null);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchResources = async () => {
      setLoadingResources(true);
      setResourcesError(null);
      try {
        const response = await fetch(
          `${TEST_BASE_URL}/articles?category=singles`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error(`API Error ${response.status}:`, errorText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Resources fetched successfully:", data);
        setResources(data?.data?.articles || []);
      } catch (error) {
        console.error("Error fetching resources:", error);
        setResourcesError(
          `Failed to load resources (${error.message}). The server may be temporarily unavailable.`
        );
        setResources([]);
      } finally {
        setLoadingResources(false);
      }
    };

    fetchResources();
  }, [token]);

  useEffect(() => {
    const fetchUpcomingEvents = async () => {
      setLoadingEvents(true);
      setEventsError(null);
      try {
        const response = await fetch(
          `${TEST_BASE_URL}/upcoming-events?category=single-focused`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error(`API Error ${response.status}:`, errorText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Events fetched successfully:", data);
        console.log("EVENT RAW RESPONSE:", data);

        const events = data?.data?.events || data?.data || data?.events || [];

        setUpcomingEvents(Array.isArray(events) ? events : []);
      } catch (error) {
        console.error("Error fetching upcoming events:", error);
        setEventsError(
          `Failed to load events (${error.message}). The server may be temporarily unavailable.`
        );
        setUpcomingEvents([]);
      } finally {
        setLoadingEvents(false);
      }
    };

    fetchUpcomingEvents();
  }, [token]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const renderEventCard = (event) => (
    <div className="col-md-4" key={event.id || Math.random()}>
      <div className="upcoming-card">
        <img
          src={event.image || event.img || event.thumbnail || newbeg}
          alt={event.title || event.name || "Event"}
          width="100%"
          onError={(e) => {
            e.target.src = newbeg;
          }}
        />
        <h6>{event.title || event.name || "Event"}</h6>
        <p className="text-white">{event.description || event.desc}</p>
        <hr />
        <div className="datediv">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M17 1V3M5 1V3"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.9955 12H11.0045M10.9955 16H11.0045M14.991 12H15M7 12H7.00897M7 16H7.00897"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.5 7H19.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.5 11.2432C1.5 6.88594 1.5 4.70728 2.75212 3.35364C4.00424 2 6.01949 2 10.05 2H11.95C15.9805 2 17.9958 2 19.2479 3.35364C20.5 4.70728 20.5 6.88594 20.5 11.2432V11.7568C20.5 16.1141 20.5 18.2927 19.2479 19.6464C17.9958 21 15.9805 21 11.95 21H10.05C6.01949 21 4.00424 21 2.75212 19.6464C1.5 18.2927 1.5 16.1141 1.5 11.7568V11.2432Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 7H20"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-white">{event.date}</span>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 20 22"
              fill="none"
            >
              <path
                d="M13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.933 6.5 13.5 8.067 13.5 10Z"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M10 1C14.8706 1 19 5.03298 19 9.92577C19 14.8965 14.8033 18.3847 10.927 20.7567C10.6445 20.9162 10.325 21 10 21C9.67495 21 9.35549 20.9162 9.073 20.7567C5.2039 18.3616 1 14.9137 1 9.92577C1 5.03298 5.12944 1 10 1Z"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
            <span className="text-white">
              {event.location ||
                event.venue ||
                event.place ||
                "Church Auditorium"}
            </span>
          </div>
        </div>
        <div className="whitebuttons">
          <a href={`/eventdetails/${event.slug}`}>See Details</a>
          <button
            onClick={() => {
              setSelectedEvent(event);
              setRsvpOpen(true);
            }}
            className="text-dark btn-link"
          >
            RSVP
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="bottom-content">
          <div className="prayer-title">
            <span>Singles Fellowship and Growth</span>
          </div>
          <div className="resources pb-4">
            <div className="resources-wrapper">
              <div className="resource-title-wrap">
                <img src={resourceicon} alt="" />
                <span>Singles' Fellowship & Growth</span>
              </div>
              <div className="resource-divider-wrapper">
                <div className="divider" />
                <span>
                  Welcome to a thriving community of single believers <br />
                  growing together in faith, purpose, and connection. <br />
                  <br />
                  Being single is not a waiting room — it's a season of <br />
                  strength, discovery, and opportunity. At RCCG New <br />
                  Beginning Chapel, we're committed to helping singles <br />
                  grow spiritually, serve faithfully, and build meaningful{" "}
                  <br />
                  relationships through intentional resources and Christ- <br />
                  centred fellowship.
                </span>
              </div>
            </div>

            <hr className="mt-5" />

            <div className="recentitle">
              <h5>Recent Resources</h5>
              <a href="/allresources">
                <small>View All Resources</small>
              </a>
            </div>

            <div className="row singlesrow">
              {loadingResources ? (
                <div className="col-12">
                  <p className="text-center">Loading resources...</p>
                </div>
              ) : resourcesError ? (
                <div className="col-12">
                  <p className="text-center text-danger">{resourcesError}</p>
                </div>
              ) : resources.length > 0 ? (
                resources.map((item) => (
                  <div className="col-md-4 mt-3" key={item.id}>
                    <div className="recentcard">
                      {item.thumbnail ? (
                        <img
                          src={
                            item.thumbnail.startsWith("http")
                              ? item.thumbnail
                              : `https://rccgbournemouth.org${
                                  item.thumbnail.startsWith("/") ? "" : "/"
                                }${item.thumbnail}`
                          }
                          alt={item.title || "Article Image"}
                          className="card-img-top"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                      ) : null}
                      <div
                        className="fallback-text"
                        style={{ display: "none" }}
                      >
                        <p>{item.title || "Image not available"}</p>
                      </div>
                      <h6>{item.title}</h6>
                      <p className="card-text">
                        {item.body?.slice(0, 120) ||
                          item.sub_title ||
                          "No description available..."}
                      </p>
                      <div className="recent-buttons">
                        {item.buttons && item.buttons.length > 0 ? (
                          item.buttons.map((btn, idx) => (
                            <a key={idx} href={btn.link}>
                              {btn.label}
                            </a>
                          ))
                        ) : (
                          <a
                            href={`/resources-article/${item.id}`}
                            className="btn btn-read-more"
                          >
                            Read More
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12">
                  <p className="text-center">No resources available.</p>
                </div>
              )}
            </div>
          </div>

          <div className="upcoming-events pb-4">
            <div className="upcoming">
              <h5 className="pt-2 pb-4">Upcoming Singles Focused Events</h5>
            </div>

            <div className="row singlesrow">
              {loadingEvents ? (
                <div className="col-12">
                  <p className="text-center">Loading events...</p>
                </div>
              ) : eventsError ? (
                <div className="col-12">
                  <p className="text-center text-danger">{eventsError}</p>
                </div>
              ) : upcomingEvents.length > 0 ? (
                upcomingEvents.map(renderEventCard)
              ) : (
                <div className="col-12">
                  <p className="text-center">
                    No upcoming events at this time.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <RSVPModal
        isOpen={rsvpOpen}
        onClose={() => setRsvpOpen(false)}
        eventId={selectedEvent?.id}
      />
    </section>
  );
}

export default SinglesFellowship;
